import { COLOR, line } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'WCLPRICE',
  version: 1,
  label: 'Weighted Close (HLCC/4)',
  pane: 'main',
  category: 'trend',
  series: 'price',
  order: 93,
  inputs: [],
  outputs: [line('wclprice', 'HLCC/4', COLOR.blue)],
  talib: { functions: ['WCLPRICE'], expr: 'WCLPRICE(high, low, close)' },
  listed: true,
  tailSafe: true,
  lookback: () => 0,
}
export default def
